module.exports = __webpack_public_path__ + "static/media/store.b6ef241b.svg";